import { gql } from "apollo-boost";
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';


/*
 *  extend type Query {
 *    getExamQuestionsByFilter(examQuestionsFilterInput: ExamQuestionFilterInput)
 *      : [ExamQuestion]
 *  }
 */
export const GET_EXAMQUESTION_LIST_BY_FILTER = gql`
  query getExamQuestionsByFilter (
    $examQuestionsFilterInput: ExamQuestionFilterInput
  ) {
    getExamQuestionsByFilter (
      examQuestionsFilterInput: $examQuestionsFilterInput
    )
    {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        ...TeacherNameFields
        picturePath
      }
      teacherCode
      unitSeq
      questionTypeCode
      nameLocal
      nameEng
      score
      isRandomChoice
      # questionType {
      #   code
      #   nameLocal
      #   nameEng
      # }
      examAnswers {
        id
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;
